var render = function render(){var _vm=this,_c=_vm._self._c;return _c('DataTable',{attrs:{"items":_vm.items,"headers":_vm.headers,"itemActions":{},"preloader":_vm.preloader},on:{"tableAction":_vm.emittedAction}})
}
var staticRenderFns = []

export { render, staticRenderFns }